import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { getInsCategoryImg } from '../navMenuUtils';
import TickIcon from '../../../icons/TickIcon';

import {
  StyledNavMenuCurrentlySelectedCustomerIcon,
  StyledNavMenuSelectCustomerContainer,
  StyledNavMenuSelectCustomerTextContent,
  StyledNavMenuSelectCustomerPolicyLogo,
} from './NavMenuSelectCustomer.styled';

function NavMenuSelectCustomer(props) {
  const { policyName, customerName, insuranceCategory, isCurrentCustomer, contractEnded } = props;

  return (
    <StyledNavMenuSelectCustomerContainer contractEnded={contractEnded}>
      <StyledNavMenuSelectCustomerPolicyLogo
        src={getInsCategoryImg(insuranceCategory)}
        alt={customerName}
      />

      <StyledNavMenuSelectCustomerTextContent>
        <Typography variant="h3">{customerName}</Typography>
        <Typography variant="p">{policyName}</Typography>
      </StyledNavMenuSelectCustomerTextContent>

      {isCurrentCustomer && (
        <StyledNavMenuCurrentlySelectedCustomerIcon>
          <TickIcon />
        </StyledNavMenuCurrentlySelectedCustomerIcon>
      )}
    </StyledNavMenuSelectCustomerContainer>
  );
}

export default NavMenuSelectCustomer;

NavMenuSelectCustomer.defaultProps = {
  isCurrentCustomer: false,
};

NavMenuSelectCustomer.defaultProps = {
  policyName: PropTypes.string,
  customerName: PropTypes.string,
  insuranceCategory: PropTypes.string,
  isCurrentCustomer: PropTypes.bool,
};
